<template>
  <div>
    <div class="setting-card">
      <div class="setting-card_header">
        <span class="setting-card_header_name">{{utility.title}}</span>
      </div>

      <div class="setting-card_content">
        <div class="setting-card_content_channels content-item" >
            <span class="title">{{utility.description}}</span>
        </div>
      </div>

      <div class="setting-card_footer">
        <span class="btn btn-success" @click="open_modal('GET', utility.url)">Request</span>
      </div>

    </div>
  </div>
</template>

<script>
import UtilitiesModal from '../../../Modal/Index.vue'

export default {
  name: "status",
  props: ['utility'],
  data () {
    return {
      error: false,
      data: ''
    }
  },
  methods: {
    open_modal(method, url, params){

      var t = this.$createElement(UtilitiesModal, {
        props: {
          type: this.utility.data_type,
          method,
          url,
          params
        },
        on: {
          close: () => { this.$modal.hide('dynamic-modal') },
          update: () => { this.getUser() }
        }
      })
      let temp = {render () { return t }}
      this.$modal.show(temp, {}, {
        height: 600,
        adaptive: true,
        clickToClose: true,
        name: 'dynamic-modal'
      })
    }
  }
}
</script>

<style lang="scss" scoped>

  .setting-card {
    border-radius: 10px;
    box-shadow: 0 2px 2px #ccc5b980;
    color: #252422;
    padding-bottom: 10px;
    position: relative;
    border: 1px solid #ccc;
    min-height: 85px;
    background-color: #f8f8f8;
    &_header {
      font: 300 14px/20px "Roboto", Arial, sans-serif;
      text-transform: uppercase;
      color: #000;
      background: #f4f3ef;
      padding: 1rem 2rem;
      border-radius: 10px 10px 0 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &_content {
      font: 300 12px/16px "Roboto", Arial, sans-serif;
      text-align: center;
      .content-item{
        display: flex;
        justify-content: center;
        align-items: flex-start;
        padding: 5px;
        &:nth-child(2n+1) {
          background-color: #e2ecdc;
        }
        .left{
          width: 40%;
        }
        .right{
          width: 60%;
        }
        div{
          display: flex;
          align-items: center;
          justify-content: flex-start;
          font-size: 12px;
          height: 100%;
          span{
            text-overflow: ellipsis;
          }
        }
      }
    }
    &_footer {
      text-align: center;
      padding: 15px 0 5px;
      border-top: 1px solid #ccc;
    }
  }

  @media (max-width: 475px) {
    .setting-card {
      &_content {
        .content-item{
          flex-wrap: wrap;
          .left{
            width: 100%;
          }
          .right{
            width: 100%;
          }
        }
      }
    }
  }


</style>
